export const mockDataPreview = {
  success: true,
  preview: {
    firstName: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 1,
          inputEntityValue: "Oscar",
          inputEntityValueMetadata: [],
          inputOwnerID: 5,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [
        // {
        //   inputEntityID: 0,
        //   inputEntityTypeID: 1,
        //   inputEntityValue: "Ken",
        //   inputEntityValueMetadata: [],
        //   inputOwnerID: 6,
        //   chosenByEndUser: false,
        // },
      ],
      needsFurtherAttention: false,
    },
    lastName: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 2,
          inputEntityValue: "Brown",
          inputEntityValueMetadata: [],
          inputOwnerID: 5,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 2,
          inputEntityValue: "White",
          inputEntityValueMetadata: [],
          inputOwnerID: 6,
          chosenByEndUser: false,
        },
      ],
      needsFurtherAttention: false,
    },
    photo: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 3,
          inputEntityValue:
            "//d6iyrqjd26xke.cloudfront.net/img19072/profile.jpg",
          inputEntityValueMetadata: [],
          inputOwnerID: 5,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 3,
          inputEntityValue:
            "//d6iyrqjd26xke.cloudfront.net/clearlakefamilycopy/profile.jpg",
          inputEntityValueMetadata: [],
          inputOwnerID: 6,
          chosenByEndUser: false,
        },
      ],
      needsFurtherAttention: false,
    },
    email: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 4,
          inputEntityValue: "markadamfoster+userafinal@gmail.com",
          inputEntityValueMetadata: {
            isVerified: true,
            verificationStatusID: 2,
          },
          inputOwnerID: 5,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 4,
          inputEntityValue: "hi@oscarbrown.com",
          inputEntityValueMetadata: {
            isVerified: false,
            verificationStatusID: 2,
          },
          inputOwnerID: 6,
          chosenByEndUser: false,
        },
      ],
      needsFurtherAttention: false,
    },
    phone: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 5,
          inputEntityValue: 5555555501,
          inputEntityValueMetadata: {
            type: "mobile_phone",
            verified: true,
            hardVerified: false,
            verificationStatusDictID: 2,
            carrier: "",
            email: "",
          },
          inputOwnerID: 5,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [
        // {
        //   inputEntityID: 0,
        //   inputEntityTypeID: 5,
        //   inputEntityValue: 4716668905,
        //   inputEntityValueMetadata: {
        //     type: "land_phone",
        //     verified: false,
        //     hardVerified: false,
        //     verificationStatusDictID: 2,
        //     carrier: "",
        //     email: "",
        //   },
        //   inputOwnerID: 6,
        //   chosenByEndUser: false,
        // },
      ],
      needsFurtherAttention: false,
    },
    additionalContactInfo: {
      finalMergedValue: [
        {
          inputEntityID: 345,
          inputEntityTypeID: 2,
          inputEntityValue: "555-555-5503",
          inputEntityValueMetadata: {
            type: "Land Phone",
          },
          ownerEntityID: 123432,
          chosenByEndUser: false,
        },
        {
          inputEntityID: 346,
          inputEntityTypeID: null,
          inputEntityValue: "555-555-5504",
          inputEntityValueMetadata: {
            type: "Mobile Phone",
          },
          ownerEntityID: 123432,
          chosenByEndUser: false,
        },
        {
          inputEntityID: 347,
          inputEntityTypeID: null,
          inputEntityValue: "cr8zysh33p@pasture.net",
          inputEntityValueMetadata: {
            type: "Email",
          },
          ownerEntityID: 123433,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [],
      needsFurtherAttention: false,
    },
    proxyContacts: {
      finalMergedValue: [
        {
          inputEntityID: 0,
          inputEntityTypeID: 7,
          inputEntityValue: 0,
          inputEntityValueMetadata: {
            proxyFor: [
              {
                userID: 580,
                photoURL:
                  "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
                displayName: "Child1 MergeTest1",
              },
              {
                userID: 581,
                photoURL:
                  "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
                displayName: "Child2 MergeTest1",
              },
            ],
            targetFor: [],
          },
          inputOwnerID: 579,
          chosenByEndUser: false,
        },
      ],
      otherInputOptions: [],
      needsFurtherAttention: false,
    },
    adminGroups: 0,
    householdName: { name: "Smith", hasGivingData: false },
    hasPassword: true,
    numRemarks: 0,
    numDocuments: 0,
    numAuthoredNotes: 1,
    numComments: 1,
    permissions: {
      1: {
        permissionDescription: "Has billing access",
        hasPermission: true,
        icon: "money-bill-wave fas far",
      },
      2: {
        permissionDescription: "Can input giving data",
        hasPermission: true,
        icon: "money-check-edit-alt fas far",
      },
      3: {
        permissionDescription: "Can view giving data",
        hasPermission: true,
        icon: "money-check-alt fas far",
      },
    },
    extendedFields: {
      // 29: {
      //   finalMergedValue: [
      //     {
      //       inputEntityID: 29,
      //       inputEntityTypeID: 9,
      //       inputEntityValue: "Option 2",
      //       inputEntityValueMetadata: {
      //         fieldTitle: "Test List Everyone",
      //         fieldIcon: "info-circle fas far",
      //         responseID: 21,
      //         fullResponse: {
      //           values: [
      //             { optionListValueID: "11", optionListValue: "Option 2" },
      //           ],
      //         },
      //         mergeUserCanView: true,
      //       },
      //       inputOwnerID: 6,
      //       chosenByEndUser: true,
      //     },
      //   ],
      //   otherInputOptions: [
      //     {
      //       inputEntityID: 29,
      //       inputEntityTypeID: 9,
      //       inputEntityValue: "Option 28",
      //       inputEntityValueMetadata: {
      //         fieldTitle: "Test List Everyone",
      //         fieldIcon: "info-circle fas far",
      //         responseID: 5,
      //         fullResponse: {
      //           values: [
      //             { optionListValueID: "11", optionListValue: "Option 2" },
      //           ],
      //         },
      //         mergeUserCanView: true,
      //       },
      //       inputOwnerID: 5,
      //       chosenByEndUser: false,
      //     },
      //   ],
      //   needsFurtherAttention: false,
      // },
      25: {
        finalMergedValue: [
          {
            inputEntityID: 25,
            inputEntityTypeID: 9,
            inputEntityValue: "some text",
            inputEntityValueMetadata: {
              fieldTitle: "Type Something",
              fieldIcon: "font fas far",
              responseID: 1,
              fullResponse: { value: "some text" },
              mergeUserCanView: true,
            },
            inputOwnerID: 5,
            chosenByEndUser: false,
          },
        ],
        otherInputOptions: [
          {
            inputEntityID: 25,
            inputEntityTypeID: 9,
            inputEntityValue:
              "some different text that is much longer to test when things start to wrap because they get supa long.",
            inputEntityValueMetadata: {
              fieldTitle: "Type Something",
              fieldIcon: "font fas far",
              responseID: 12,
              fullResponse: { value: "some text" },
              mergeUserCanView: true,
            },
            inputOwnerID: 6,
            chosenByEndUser: false,
          },
        ],
        needsFurtherAttention: false,
      },
      // 26: {
      //   finalMergedValue: [
      //     {
      //       inputEntityID: 26,
      //       inputEntityTypeID: 9,
      //       inputEntityValue: "1",
      //       inputEntityValueMetadata: {
      //         fieldTitle: "Test Number Everyone",
      //         fieldIcon: "info-circle fas far",
      //         responseID: 2,
      //         fullResponse: { value: "1" },
      //         mergeUserCanView: true,
      //       },
      //       inputOwnerID: 5,
      //       chosenByEndUser: false,
      //     },
      //   ],
      //   otherInputOptions: [
      //     {
      //       inputEntityID: 26,
      //       inputEntityTypeID: 9,
      //       inputEntityValue: "12345",
      //       inputEntityValueMetadata: {
      //         fieldTitle: "Test Number Everyone",
      //         fieldIcon: "info-circle fas far",
      //         responseID: 13,
      //         fullResponse: { value: "1" },
      //         mergeUserCanView: true,
      //       },
      //       inputOwnerID: 6,
      //       chosenByEndUser: false,
      //     },
      //   ],
      //   needsFurtherAttention: false,
      // },
      27: {
        finalMergedValue: [
          {
            inputEntityID: 27,
            inputEntityTypeID: 9,
            inputEntityValue: "123 Main St, Atlanta, GA, 00000",
            inputEntityValueMetadata: {
              fieldTitle: "Address",
              fieldIcon: "map fas far",
              responseID: 3,
              fullResponse: {
                country: "",
                addr1: "123",
                city: "City",
                state: "GA",
                zip: "00000",
              },
              mergeUserCanView: true,
            },
            inputOwnerID: 5,
            chosenByEndUser: false,
          },
        ],
        otherInputOptions: [
          // {
          //   inputEntityID: 27,
          //   inputEntityTypeID: 9,
          //   inputEntityValue: "3623 W Kipling Rd, Boise, ID, 83706",
          //   inputEntityValueMetadata: {
          //     fieldTitle: "Test Address Everyone",
          //     fieldIcon: "info-circle fas far",
          //     responseID: 14,
          //     fullResponse: {
          //       country: "",
          //       addr1: "123",
          //       city: "City",
          //       state: "GA",
          //       zip: "00000",
          //     },
          //     mergeUserCanView: true,
          //   },
          //   inputOwnerID: 6,
          //   chosenByEndUser: false,
          // },
        ],
        needsFurtherAttention: false,
      },
      28: {
        finalMergedValue: [
          {
            inputEntityID: 28,
            inputEntityTypeID: 9,
            inputEntityValue: "January 1, 2000",
            inputEntityValueMetadata: {
              fieldTitle: "Test Date",
              fieldIcon: "calendar fas far",
              responseID: 4,
              fullResponse: { month: "1", day: "1", year: "2000" },
              mergeUserCanView: true,
            },
            inputOwnerID: 5,
            chosenByEndUser: false,
          },
        ],
        otherInputOptions: [
          // {
          //   inputEntityID: 28,
          //   inputEntityTypeID: 9,
          //   inputEntityValue: "February 28, 1999",
          //   inputEntityValueMetadata: {
          //     fieldTitle: "Test Date Everyone",
          //     fieldIcon: "info-circle fas far",
          //     responseID: 15,
          //     fullResponse: { month: "1", day: "1", year: "2000" },
          //     mergeUserCanView: true,
          //   },
          //   inputOwnerID: 6,
          //   chosenByEndUser: false,
          // },
        ],
        needsFurtherAttention: false,
      },
    },
  },
  isApp: false,
  userID: 2,
};
